module.exports = __webpack_public_path__ + "images/pages/for_business/pc/fv_d1056e5987747368c42e8b486db727aa.jpg";